export enum QR_CODE_STATUS {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_WITHDRAW = 'WAITING_WITHDRAW',
  COMPLETED = 'COMPLETED',
  EXPIRATED = 'EXPIRATED',
}
